import { inject, Injectable } from '@angular/core';
import { fakturaApi, fakturaDtos } from '@vectronic/openApi-admin';
import { BehaviorSubject, catchError, map, Observable, of, shareReplay, switchMap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FakturaService {
  private fakturaCustomerApi = inject(fakturaApi.Customer);

  refresh$ = new BehaviorSubject(null);
  customers$: Observable<fakturaDtos.Customer[]> = this.refresh$.pipe(
    switchMap(() => this.fakturaCustomerApi.getCustomers()),
    catchError(() => of([])),
    shareReplay(1),
  );

  static getStringByCustomer(customer: fakturaDtos.Customer): string {
    return customer
      ? `${customer.customerReferenceNumber} - ${customer.name} (${customer.organisation})`
      : '';
  }

  getCustomer(customerRefNo: string): Observable<fakturaDtos.Customer> {
    return this.fakturaCustomerApi.getCustomers([customerRefNo]).pipe(
      catchError(() => of([])),
      map((list) => (list ? list[0] : null)),
    );
  }
}
